var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.906,
    height: 37.771,
    viewBox: "0 0 27.906 37.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin_1_",
    "data-name": "pin (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M62.033,0A13.968,13.968,0,0,0,48.08,13.953a16.1,16.1,0,0,0,1.184,5.372,22.5,22.5,0,0,0,1.613,3.016l9.567,14.5a1.82,1.82,0,0,0,3.18,0l9.568-14.5A22.41,22.41,0,0,0,74.8,19.325a16.094,16.094,0,0,0,1.183-5.372A13.969,13.969,0,0,0,62.033,0ZM73.29,18.688a20.618,20.618,0,0,1-1.47,2.75l-9.568,14.5c-.189.286-.249.286-.437,0l-9.568-14.5a20.627,20.627,0,0,1-1.47-2.75,14.613,14.613,0,0,1-1.055-4.734,12.311,12.311,0,1,1,24.623,0A14.624,14.624,0,0,1,73.29,18.688Z",
    transform: "translate(-48.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M119.467,64.008a7.387,7.387,0,1,0,7.387,7.387A7.4,7.4,0,0,0,119.467,64.008Zm0,13.132a5.745,5.745,0,1,1,5.745-5.745A5.752,5.752,0,0,1,119.467,77.14Z",
    transform: "translate(-105.514 -57.441)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.4d52b9a6f0619e7b044ebb8906398433.svg";
export { ForwardRef as ReactComponent };